import React from 'react';

const IconHeartFilled = ({ onClick }) => {
	return (
		<div className='IconHeartFilled' onClick={onClick}>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M9.27156 3.65234L9.99979 4.35186L10.7247 3.65553C11.5604 2.98469 12.5906 2.61523 13.6573 2.61523C14.9315 2.61523 16.1534 3.14229 17.0541 4.0804C17.9553 5.01814 18.4615 6.29021 18.4615 7.61664C18.4615 8.94313 17.9552 10.2153 17.0541 11.1529L11.0448 17.4089C10.4676 18.0098 9.53195 18.0098 8.95483 17.4089L2.94545 11.1529C1.06945 9.19987 1.06945 6.03341 2.94545 4.0804C4.67258 2.28238 7.38764 2.13969 9.27156 3.65234Z" fill="#344054" />
			</svg>
		</div>
	)
}

export default IconHeartFilled;